/* ===================== VIATRIX v38 ===================== */
(() => {
  if (window.vx38) return; window.vx38 = 1;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  const IO = 'IntersectionObserver' in window;

  /* Carrossel genérico que passa sozinho e para quando a cliente mexe */
  const autoRail = (rail, ms, itemSel) => {
    if (!rail || rail.dataset.vx38Auto || reduce) return;
    rail.dataset.vx38Auto = '1';
    let pausedUntil = 0, visible = !IO;
    const pause = (t) => { pausedUntil = Date.now() + t; };
    const step = (dir = 1) => {
      const card = itemSel ? rail.querySelector(itemSel) : rail.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
      const w = card.getBoundingClientRect().width + gap;
      const max = rail.scrollWidth - rail.clientWidth - 8;
      const from = rail.scrollLeft;
      let to = from + dir * w;
      if (dir > 0 && from >= max) to = 0;
      else if (dir < 0 && from <= 8) to = max + 8;
      rail.scrollTo({ left: to, behavior: 'smooth' });
      setTimeout(() => { if (Math.abs(rail.scrollLeft - from) < 2) rail.scrollLeft = to; }, 900);
    };
    ['pointerdown', 'touchstart', 'wheel'].forEach((ev) => rail.addEventListener(ev, () => pause(9000), { passive: true }));
    if (fine) { rail.addEventListener('mouseenter', () => pause(1e9)); rail.addEventListener('mouseleave', () => pause(1500)); }
    if (IO) new IntersectionObserver((es) => es.forEach((e) => { visible = e.intersectionRatio > 0.3; }), { threshold: [0, 0.3, 0.6] }).observe(rail);
    setInterval(() => { if (visible && !document.hidden && Date.now() >= pausedUntil) step(1); }, ms);
    rail.vx38Step = (d) => { pause(9000); if (d) step(d); };
  };

  /* Instagram: passa sozinho */
  document.querySelectorAll('.vx-rail--ig').forEach((r) => {
    autoRail(r, 3400);
    const sec = r.closest('section') || r.parentElement;
    sec && sec.querySelectorAll('.vx-nav__b').forEach((b) => b.addEventListener('click', () => r.vx38Step && r.vx38Step(0)));
  });

  /* Complete o look (página de produto) */
  document.querySelectorAll('[data-vx38-ctl-rail]').forEach((r) => {
    autoRail(r, 2800, '.vx-ctl__item');
    const box = r.closest('.vx-ctl');
    box && box.querySelectorAll('[data-vx38-ctl]').forEach((b) => b.addEventListener('click', () => {
      const d = +b.dataset.vx38Ctl;
      if (r.vx38Step) r.vx38Step(d);
      else r.scrollBy({ left: d * r.clientWidth * 0.6, behavior: 'smooth' });
    }));
  });

  /* Conjuntos: separadores + deslizar */
  document.querySelectorAll('.vx38-sets').forEach((sec) => {
    const track = sec.querySelector('[data-vx38-sets]');
    const tabs = [...sec.querySelectorAll('[data-vx38-tab]')];
    if (!track) return;
    const go = (k) => { const c = track.children[k]; c && track.scrollTo({ left: c.offsetLeft - track.offsetLeft, behavior: 'smooth' }); };
    tabs.forEach((t) => t.addEventListener('click', () => go(+t.dataset.vx38Tab)));
    let tm;
    track.addEventListener('scroll', () => {
      clearTimeout(tm);
      tm = setTimeout(() => {
        const w = track.children[0] ? track.children[0].getBoundingClientRect().width : track.clientWidth;
        const k = Math.round(track.scrollLeft / (w + 12));
        tabs.forEach((t, j) => t.classList.toggle('is-on', j === k));
      }, 80);
    }, { passive: true });
  });

  /* Vista rápida: ao escolher Prateado/Dourado, mostra a foto dessa cor */
  const pcache = {};
  const getP = (url) => {
    const h = (url || '').split('/products/')[1];
    if (!h) return Promise.resolve(null);
    const handle = h.split(/[?#]/)[0];
    if (!pcache[handle]) pcache[handle] = fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'products/' + handle + '.js').then((r) => r.json()).catch(() => null);
    return pcache[handle];
  };
  const key = (s) => (s || '').split('?')[0].split('/').pop();
  const showVariantImg = async (body, vid) => {
    const more = body.querySelector('.vx-qv__more');
    const gal = body.querySelector('[data-qv-gal]');
    if (!more || !gal) return;
    const p = await getP(more.getAttribute('href'));
    if (!p) return;
    const v = p.variants.find((x) => String(x.id) === String(vid));
    const fi = v && v.featured_image && v.featured_image.src;
    if (!fi) return;
    const imgs = [...gal.querySelectorAll('img')];
    const k = imgs.findIndex((im) => key(im.getAttribute('src')) === key(fi));
    if (k < 0) return;
    const to = k * gal.clientWidth;
    gal.scrollTo({ left: to, behavior: 'smooth' });
    setTimeout(() => { if (Math.abs(gal.scrollLeft - to) > 4) gal.scrollLeft = to; }, 700);
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.vx-qv [data-qv-v]');
    if (!b) return;
    const body = b.closest('.vx-qv__body');
    body && showVariantImg(body, b.dataset.qvV);
  });

  /* Aparecer ao fazer scroll: confiança, FAQ, vantagens do rodapé */
  if (!reduce && IO) {
    document.documentElement.classList.add('vx38-js');
    const groups = ['.vx-promise__list > li', '.vx-faq__list > .vx-faq__i', '.vx-foot__trust-row > .vx-foot__t'];
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.15 });
    groups.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el, i) => {
        el.classList.add('vx38-rv');
        el.style.setProperty('--vx38-d', (window.innerWidth < 750 ? (i % 2) * 0.08 : i * 0.08) + 's');
        io.observe(el);
      });
    });
    setTimeout(() => document.querySelectorAll('.vx38-rv:not(.is-in)').forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
    }), 1200);
  }
})();